// extracted by mini-css-extract-plugin
export default {"-large":"BpcWjPUQoZwoK2mlUbzP","popup":"cOWGTEZ6gUVJBdoZlDfw","popUpContainer":"SrkADVhqtcEJumKk1Fwa"};